import Seo from "../components/Seo";
import PageHeader from "../components/PageHeader";
import CtaSection from "../components/CtaSection";
import FaqSection from "../components/FaqSection";
import { GENERAL_FAQS, FAQ_JSONLD } from "../lib/site";

export default function Faq() {
  return (
    <>
      <Seo
        title="Frequently Asked Questions | Directive Optive Solutions"
        description="Who we work with, what services we offer, how to start, what it costs, and how your information stays safe. Answered plainly."
        path="/faq"
        jsonLd={FAQ_JSONLD}
      />
      <PageHeader
        eyebrow="FAQ"
        title="Questions, answered plainly."
        lead="If your question isn’t here, call us, write to us, or book a consultation. We’d rather answer it directly than in fine print."
        image="/img/photo-team-support.webp"
        imageAlt="Four smiling Directive Optive Solutions team members standing together in the office"
      />

      <section className="py-24 lg:py-32" data-testid="faq-page-section">
        <div className="container-shell max-w-4xl">
          <FaqSection items={GENERAL_FAQS} testPrefix="faq-page" />
        </div>
      </section>

      <CtaSection />
    </>
  );
}
